/* eslint-disable camelcase */

import {
  RELEASE_PRIORITIES,
  RELEASE_SCOPES,
  RELEASE_SEGMENTS,
} from './constants'

export const mockReleaseNotes = [
  {
    id: 'rn-2026-05-20-test',
    title: 'Тестовый релиз',
    summary:
      'Проверка работы крестика, открытия карточки и формы обратной связи.',
    body: 'Проверка работы крестика в модальном окне.\nТестирование открытия и закрытия карточки.\nПроверка отправки формы обратной связи.\nВалидация работы обратной связи через email.',
    product_scope: RELEASE_SCOPES.BOTH,
    priority: RELEASE_PRIORITIES.CRITICAL,
    status: 'published',
    audience_roles: ['owner', 'manager'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [],
    cta_label: 'Подробнее',
    cta_url: '/release-notes',
    published_at: '2026-05-20T10:00:00Z',
    opened: false,
  },
  {
    id: 'rn-2026-05-15-security',
    title: 'Обновление безопасности домофонной системы',
    summary:
      'Исправлена уязвимость в SIP-стеке, обновлены сертификаты безопасности.',
    body: 'Исправлена уязвимость CVE-2026-3842 в протоколе SIP.\nДобавлено шифрование AES-256-GCM для аудиопотока.\nОбновлена прошивка 4.12 для всех устройств.',
    product_scope: RELEASE_SCOPES.BOTH,
    priority: RELEASE_PRIORITIES.CRITICAL,
    status: 'published',
    audience_roles: ['owner', 'manager'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [
      'https://placehold.co/800x400/0EA7FF/white?text=Screenshot+1',
      'https://placehold.co/800x400/F64D4D/white?text=Screenshot+2',
    ],
    cta_label: 'Подробнее',
    cta_url: '/release-notes',
    published_at: '2026-05-15T10:00:00Z',
    opened: false,
  },
  {
    id: 'rn-2026-04-21-money',
    title: 'Стандартизация пополнений и списаний',
    summary:
      'Разделили реальные и виртуальные деньги, добавили стандартизированные основания для УПД и аналитики.',
    body: 'High-impact релиз: проверьте новые типы операций и влияние на УПД.',
    product_scope: RELEASE_SCOPES.BOTH,
    priority: RELEASE_PRIORITIES.CRITICAL,
    status: 'published',
    audience_roles: ['owner', 'manager'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [],
    cta_label: 'Открыть раздел',
    cta_url: '/release-notes',
    published_at: '2026-04-21T12:00:00Z',
    opened: false,
  },
  {
    id: 'rn-2026-04-16-analytics',
    title: 'Новая аналитика по типам операций',
    summary: 'Добавлены разрезы по компенсациям, выплатам и ВЭД-операциям.',
    body: 'Medium релиз: доступно в аналитике кабинета.',
    product_scope: RELEASE_SCOPES.PARTNER,
    priority: RELEASE_PRIORITIES.MEDIUM,
    status: 'published',
    audience_roles: ['owner', 'manager', 'operator'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [],
    cta_label: 'Смотреть аналитику',
    cta_url: '/release-notes',
    published_at: '2026-04-16T09:00:00Z',
    opened: false,
  },
  {
    id: 'rn-2026-04-10-design',
    title: 'Обновление дизайна панели управления',
    summary:
      'Полностью переработан интерфейс дашборда: новые виджеты, тёмная тема.',
    body: 'Встречайте обновлённый дашборд с тёмной темой.',
    product_scope: RELEASE_SCOPES.PARTNER,
    priority: RELEASE_PRIORITIES.LOW,
    status: 'published',
    audience_roles: ['owner', 'manager', 'operator'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [],
    cta_label: 'Посмотреть',
    cta_url: '/release-notes',
    published_at: '2026-04-10T08:00:00Z',
    opened: false,
  },
  {
    id: 'rn-2026-04-01-export',
    title: 'Экспорт отчета в PDF',
    summary:
      'Добавлена возможность экспорта отчётов по финансам в PDF одним кликом.',
    body: 'Экспорт доступен в разделе аналитики.',
    product_scope: RELEASE_SCOPES.CONTROL,
    priority: RELEASE_PRIORITIES.HIGH,
    status: 'published',
    audience_roles: ['owner', 'manager'],
    audience_segments: RELEASE_SEGMENTS,
    attachments: [],
    cta_label: 'Попробовать',
    cta_url: '/release-notes',
    published_at: '2026-04-01T09:00:00Z',
    opened: false,
  },
]

export const mockAdminReleaseNotes = [
  {
    id: 'rn-2026-05-20-test',
    title: 'Тестовый релиз',
    product_scope: RELEASE_SCOPES.BOTH,
    status: 'published',
    published_at: '2026-05-20T10:00:00Z',
    priority: RELEASE_PRIORITIES.CRITICAL,
  },
  {
    id: 'rn-2026-05-15-security',
    title: 'Обновление безопасности домофонной системы',
    product_scope: RELEASE_SCOPES.BOTH,
    status: 'published',
    published_at: '2026-05-15T10:00:00Z',
    priority: RELEASE_PRIORITIES.CRITICAL,
  },
  {
    id: 'rn-2026-04-21-money',
    title: 'Стандартизация пополнений и списаний',
    product_scope: RELEASE_SCOPES.BOTH,
    status: 'published',
    published_at: '2026-04-21T12:00:00Z',
    priority: RELEASE_PRIORITIES.CRITICAL,
  },
  {
    id: 'rn-2026-06-01-scheduled',
    title: 'Поддержка новых моделей домофонов',
    product_scope: RELEASE_SCOPES.CONTROL,
    status: 'scheduled',
    published_at: '2026-06-10T08:00:00Z',
    priority: RELEASE_PRIORITIES.MEDIUM,
  },
  {
    id: 'rn-2026-05-20-draft',
    title: 'Интеграция с платёжным шлюзом',
    product_scope: RELEASE_SCOPES.PARTNER,
    status: 'draft',
    published_at: '2026-05-20T14:00:00Z',
    priority: RELEASE_PRIORITIES.LOW,
  },
  {
    id: 'rn-2026-05-01-archive',
    title: 'Миграция на новую версию API',
    product_scope: RELEASE_SCOPES.BOTH,
    status: 'archived',
    published_at: '2026-05-01T00:00:00Z',
    priority: RELEASE_PRIORITIES.HIGH,
  },
]
